import { Component } from '@angular/core';
import { HasRoleDirective } from '../../../_core/directives/has-role.directive';

@Component({
  selector: 'app-footer',
  imports: [HasRoleDirective],
  templateUrl: './footer.html',
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
}
